import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient, Session } from '@benzinga/session';
import { ContentEnvironment } from '../environment';
import {
  CreateImpressionsParams,
  GetImpressionResponse,
  GetImpressionsParams,
  Impression,
  RegisterImpressionResponse,
} from '../entities';

export class ContentRestfulImpressions extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ContentEnvironment).url, session);
  }

  getContentImpressions = (params: GetImpressionsParams): SafePromise<GetImpressionResponse> => {
    const query = new URLSearchParams();

    if (Array.isArray(params.content_ids)) {
      params.content_ids.forEach(item => {
        query.append(`content_ids[]`, String(item));
      });
    }

    if (params?.register_impression) {
      query.append(`register_impression`, String(Number(params?.register_impression)));
    }

    const url = this.URL(`content-impressions?` + query);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', includeHeader: {} });
  };

  createContentImpressions = (params: CreateImpressionsParams): SafePromise<Impression[]> => {
    const url = this.URL('content-impressions');
    return this.post(url, params, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  registerContentImpression = (content_id: number): SafePromise<RegisterImpressionResponse> => {
    const url = this.URL(`content-impressions/${content_id}/register`);
    return this.patch(url, {}, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  updateContentLimitation = (content_id: string, params: Partial<Impression>): SafePromise<Impression> => {
    const url = this.URL(`content-impressions/${content_id}`);
    return this.patch(url, params, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
